import { Controller } from "@hotwired/stimulus"

// Skill picker's "Любой скилл" tab: the level <select> loads every SkillLevel
// once (each <option> tagged with data-skill-id), this controller just hides
// the ones that don't belong to the currently chosen skill so the picker only
// ever shows levels for that skill. If the skill has none, every option stays
// hidden and the field is submitted blank — the server falls back to
// Skill#default_level!.
export default class extends Controller {
  static targets = ["skillSelect", "levelSelect"]

  connect() {
    this.filter()
  }

  filter() {
    const skillId = this.skillSelectTarget.value
    let firstMatch = ""

    Array.from(this.levelSelectTarget.options).forEach((option) => {
      if (!option.value) return // keep the blank "select a level" prompt as-is

      const matches = option.dataset.skillId === skillId
      option.hidden = !matches
      option.disabled = !matches
      if (matches && !firstMatch) firstMatch = option.value
    })

    this.levelSelectTarget.value = firstMatch
  }
}
